module.exports = __webpack_public_path__ + "static/media/retirement-object-4-1-0.9a0da4c6.png";